import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {}
})

export default useStyles
